import { NEEDS, DRAIN, TRAITS } from '../../shared/content/life.js';

// The player's life as the client sees it: the server's last word on the needs, drained locally
// at the same rates until the next word, so the bars move between messages.
export class Life {
  constructor(net, hud) {
    this.hud = hud;
    this.state = null; // the server's view
    this.needs = null; // the locally drained copy
    this.home = null; // { x, z, name }
    net.on('life', (m) => {
      this.state = m.life;
      this.needs = { ...m.life.needs };
      if (m.home) this.home = m.home;
      if (this.home && this.onHome) this.onHome(this.state.vehicles || [], this.home);
      if (m.rent !== undefined) this.rent = m.rent;
      if (m.known !== undefined) this.known = m.known;
      if (m.money !== undefined && this.onMoney) this.onMoney(m.money);
      this.show();
    });
  }

  update(dt) {
    if (!this.needs) return;
    const slow = {};
    for (const t of this.state.traits || []) {
      const tr = TRAITS[t];
      if (tr && tr.drain) for (const [need, k] of Object.entries(tr.drain)) slow[need] = (slow[need] || 1) * k;
    }
    for (const n of NEEDS) this.needs[n] = Math.max(0, this.needs[n] - (DRAIN[n] * (slow[n] || 1) * dt) / 3600);
    this.shown = (this.shown || 0) + dt;
    if (this.shown > 1) {
      this.shown = 0;
      this.show();
    }
  }

  show() {
    if (this.needs) this.hud.setNeeds(this.needs);
  }

  // How much the player is slowed by hunger and tiredness: 1 is full speed.
  pace() {
    if (!this.needs) return 1;
    const worst = Math.min(this.needs.hunger, this.needs.energy);
    return worst < 10 ? 0.5 : worst < 25 ? 0.7 : 1;
  }

  // True when standing at home.
  atHome(x, z) {
    return !!this.home && Math.hypot(this.home.x - x, this.home.z - z) < 45;
  }
}
